import {
  RSetState,
  NPersonal,
  EPostUser,
  EGetUser,
  EPutPassword,
  EPostMyInfo,
  EDelMyInfo,
  EPostCollectInfo,
  EGetUserCollect,
  EGetMessage,
  EUpdateMessage,
  EWechatQRCode,
  ETokenByWechat,
  EBindUserByWechat,
  NUser,
} from './constants'
import {
  getUser,
  postUser,
  putPassword,
  postMyInfo,
  delMyInfo,
  getUserCollect,
  postCollectInfo,
  getMessage,
  updateMessage,
  getWechatQrCode,
  postTokenByWechat,
  postBindUserByWechat,
} from '../services'
import { bindJWTToken } from '../dva16'
const QRCodeStatus = {
  WaitScan: '等待扫码',
  LoginSuccess: '登录成功',
  BindUserSuccess: '绑定成功',
  NoBindFailed: '未绑定该微信',
}

export default {
  namespace: NPersonal,
  state: {
    userInfo: {},
    myInfo: {
      data: [],
      total: 0,
      pager: 1,
    },
    myCollect: {
      data: [],
      total: 0,
      pager: 1,
    },
    myMessage: null,

    // 微信相关
    qrcode: null,
  },
  reducers: {
    [RSetState](state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },
  effects: {
    async [EGetUser]({ payload }, { call, reducer, select, effect }) {
      const data = await call(getUser)
      reducer(RSetState, { userInfo: data })
    },
    async [EPostUser]({ payload }, { call, reducer, select, effect }) {
      await call(postUser, payload)
      effect(EGetUser)
    },
    async [EPutPassword]({ payload }, { call, reducer, select, effect }) {
      await call(putPassword, payload)
    },
    async [EPostMyInfo]({ payload }, { call, reducer, select, effect }) {
      const { myInfo } = select(NPersonal)
      const data = await call(postMyInfo, { perPage: 10, page: myInfo.pager, ...payload })
      reducer(RSetState, { myInfo: data })
    },

    async [EDelMyInfo]({ payload }, { call, reducer, select, effect }) {
      await call(delMyInfo, payload)
      effect(NPersonal, EPostMyInfo, payload)
    },

    async [EGetUserCollect]({ payload }, { call, reducer, select, effect }) {
      const { myCollect } = select(NPersonal)
      const data = await call(getUserCollect, { perPage: 10, page: myCollect.pager, ...payload })
      reducer(RSetState, { myCollect: data })
    },

    async [EPostCollectInfo]({ payload }, { call, reducer, select, effect }) {
      await call(postCollectInfo, payload)
      effect(NPersonal, EGetUserCollect, payload)
    },
    async [EGetMessage]({ payload }, { call, reducer }) {
      const result = await call(getMessage, payload)
      reducer(RSetState, { myMessage: result })
    },
    async [EUpdateMessage]({ payload }, { call, reducer }) {
      const result = await call(updateMessage, { id: payload.id })
      const messages = await call(getMessage, { page: payload.page })
      reducer(RSetState, { myMessage: messages })
    },

    /*------------------------------ 微信相关 ------------------------------*/
    async [EWechatQRCode]({ payload }, { call, reducer }) {
      const qrcode = await call(getWechatQrCode)
      reducer(RSetState, { qrcode })
    },
    async [ETokenByWechat]({ payload }, { call, reducer, select }) {
      let { qrcode } = select(NPersonal)
      const result = await call(postTokenByWechat, { code: qrcode.code })
      console.log(result)
      if (result.error) {
      } else if (result.status != QRCodeStatus.WaitScan) {
        let { user, token } = result
        reducer(NUser, RSetState, { user })
        bindJWTToken(token)
        localStorage.setItem('user', JSON.stringify(user))
        localStorage.setItem('k3Token', token)
        window.location.href = '#/'
        window.location.reload()
      }
    },
    async [EBindUserByWechat]({ payload }, { call, reducer, select, effect }) {
      const result = await call(postBindUserByWechat, payload)
      if (payload.code) {
        if (result.error) {
        } else if (result.status != QRCodeStatus.WaitScan) {
          reducer(RSetState, { qrcode: null })
          effect(EGetUser)
        }
      } else {
        effect(EGetUser)
      }
    },
  },
}
